<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card class="">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>contact_page</md-icon>
        </div>
        <h4 class="title">{{ data.label }}</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-layout-data">
            <md-table class="">
              <md-table-row
                v-for="(row, rowIndex) in data.data"
                :key="rowIndex"
              >
                <md-table-cell
                  class="cursor-mail"
                  @click.native="handleMail(row)"
                  >{{ getFullName(row) }}: {{ row.email }}</md-table-cell
                >
                <md-table-cell>
                  <a :href="'tel:' + convertPhoneToInternational(row.phone)">
                    {{ formatPhone(row.phone) }}
                  </a>
                  <template v-if="row.phone && row.mobile">
                    /
                  </template>
                  <a :href="'tel:' + convertPhoneToInternational(row.mobile)">
                    {{ formatPhone(row.mobile) }}
                  </a>
                </md-table-cell>
              </md-table-row>
              <md-table-row v-if="data.data.length === 0">
                <md-table-cell
                  >Deze widget heeft geen data om weer te geven.</md-table-cell
                >
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["data"],
  methods: {
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("‑");
    },
    formatPhone(phoneNumber) {
      if (typeof phoneNumber !== "string") {
        return phoneNumber;
      }

      phoneNumber = phoneNumber.split("-");

      if (phoneNumber.length == 2 && phoneNumber[0].length == 2) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 2) +
          " " +
          phoneNumber[1].substr(2, 3) +
          " " +
          phoneNumber[1].substr(5, 3);
      } else if (phoneNumber.length == 2 && phoneNumber[0].length == 3) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 3) +
          " " +
          phoneNumber[1].substr(3, 2) +
          " " +
          phoneNumber[1].substr(5, 2);
      } else if (phoneNumber.length == 2 && phoneNumber[0].length == 4) {
        phoneNumber[1] =
          phoneNumber[1].substr(0, 3) + " " + phoneNumber[1].substr(3, 3);
      }

      return phoneNumber.join("‑");
    },
    convertPhoneToInternational(phoneNumber) {
      if (typeof phoneNumber !== "string") {
        return phoneNumber;
      }

      return "+31" + phoneNumber.substr(1, 10).replace("-", "");
    },
    getFullName(data) {
      return (
        data["first_name"] +
        " " +
        (data["last_name_prefix"] ? data["last_name_prefix"] + " " : "") +
        data["last_name"]
      );
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-layout-data {
  max-height: 200px;
  overflow-y: auto;
}
.md-card .md-table-cell.cursor-mail {
  cursor: url("/img/default/pointers/mail.svg"), auto;
}
</style>
